export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20abstract%20composition%20with%20flowing%20translucent%20fabric%20layers%20in%20warm%20terracotta%20blush%20pink%20and%20creamy%20ivory%20tones%2C%20organic%20wavelike%20textures%20with%20gentle%20gradients%2C%20diffused%20golden%20hour%20backlighting%20creating%20a%20dreamy%20ethereal%20atmosphere%2C%20artistic%20editorial%20photography%20style%20with%20luxurious%20minimalist%20feel%2C%20subtle%20motion%20blur%20and%20soft%20luminous%20accents&width=1800&height=1200&seq=hero-main-v4-2026&orientation=landscape"
          alt="LitBuy Spreadsheet - Premium Shopping Resource Center"
          title="LitBuy Spreadsheet Resource Hub"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/40"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white mb-4 tracking-tight">
          LITBUY SPREADSHEET
        </h1>
        <p className="text-lg md:text-2xl font-heading italic text-white/90 mb-3">
          The Ultimate Shopping Resource
        </p>
        <p className="text-sm md:text-base text-white/70 max-w-xl mx-auto leading-relaxed mb-8">
          Discover the most comprehensive LitBuy spreadsheet guides, templates, and comparison tools.
          Your one-stop destination for smarter shopping decisions in 2026.
        </p>
        <a
          href="https://kaspreadsheet.com/"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-white text-foreground-950 text-base font-semibold whitespace-nowrap cursor-pointer hover:bg-background-100 hover:scale-105 transition-all duration-300 shadow-lg"
        >
          litbuy spreadsheet
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 rounded-full border-2 border-white/40 flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 bg-white/60 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}